// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1[data-v-b691b842]{font-size:1.875rem;font-weight:300;line-height:1.375;margin-bottom:1rem}h1 span[data-v-b691b842]{font-weight:600}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
